let host, api_url;

host = "http://localhost:8080",
console.log(window.location,9988)
if(window.location.host == 'track.freightcloud.net' || window.location.host=='localhost:8099'){// 测试环境2
    host = "https://track.freightcloud.net",
    api_url = "https://api.track.freightcloud.net"
}
if(window.location.host== 'track.freightcloud.net'){ //develop1
    host = "https://track.freightcloud.net",
    api_url = "https://api.track.freightcloud.net"
}




export let HOST = host;
export let API_URL = api_url;


// WEBPACK FOOTER //
// ./src/baseurl.js